<div class="Page404">
  <div class="Page404__wrap container">
    <div class="Page404__row row">
      <div class="Page404__leftColumn col-md-6">

      </div>
      <div class="Page404__rightColumn col-md-6">
        <h1 class="Page404__title">No Results Found</h1>
        <p class="Page404__infoText">It looks like you have taken a wrong turn…<br>
          Don’t worry! It happens to the best of us.</p>
        <div class="helpfulText Page404__helpfulText">
          <div class="helpfulText__wrap">
            <p><b>Here are a few links that may be helpful:</b></p>
            <div class="helpfulText__links">
              <a href="https://wickedlist.com" title="home page">Home</a>
              <a href="https://wickedlist.com/b/contact-us/" title="Contact Us">Contact Us</a>
            </div>
          </div>
        </div>
      </div>
      <div class="Page404__extraImage col-md-12">

      </div>
    </div>
  </div>
</div>
